import React from 'react';

import Login from '../base/youagain';

import {LoginCard, RolesCard, StatusCard} from '../base/components/AccountPageWidgets';
import Misc from '../base/components/Misc';
import DataStore from '../base/plumbing/DataStore';
import {LoginLink} from '../base/components/LoginWidget';


function GoodLoopAccountPage() {
	if ( ! Login.isLoggedIn()) {
		return <div><h1>My Account: Please login</h1><LoginLink title="Login" /></div>;
	}

	return (
		<div className="">
			<h1>My Account</h1>
			<LoginCard />
			<RolesCard />
			<ListShares />
			<StatusCard />
		</div>
	);
}


function ListShares() {
	let sharesPV = DataStore.fetch(['widget', 'account', 'sharedPubPages'], () => {
		let req = Login.getSharedWith(Login.getId());
		return req;
	});
	
	if(!sharesPV.value) return <Misc.Loading />;

	return (
		<Misc.Card title="Your pages">
			{
				sharesPV.value.map(share => {
					console.warn(share);
					const url = share.item.match(/:(.+)$/)?.[1];
					return (
						<span key={url}>
							<a href={`/#pubdash/${url}`}>{url}</a><br />
						</span>
					);
				})
			}
		</Misc.Card>
	);
}


export {
	GoodLoopAccountPage,
	ListShares
};
